import React from "react";
import { FormControl, Button } from "react-bootstrap";

export default function Subscribe(props) {
  let { placeholder } = props;
  placeholder = undefined === placeholder ? "Correo electrónico" : placeholder;
  return (
    <div className="c-input-subscribe">
      <div className="c-input-s">
        <FormControl
          placeholder={placeholder}
          aria-label={placeholder}
          aria-describedby="basic-addon2"
        />
      </div>
      <div className="c-subsbtn">
        <Button id="basic-addon2">SUBSCRÍBETE</Button>
      </div>
    </div>
  );
}
